import { render } from "./DisplayTextField.vue?vue&type=template&id=3e60ae5a&scoped=true"
import script from "./DisplayTextField.vue?vue&type=script&lang=js"
export * from "./DisplayTextField.vue?vue&type=script&lang=js"

import "./DisplayTextField.vue?vue&type=style&index=0&id=3e60ae5a&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e60ae5a"]])

export default __exports__